import React, { useRef } from 'react';

type Callbacks = {
    left?: () => void,
    right?: () => void,
    top?: () => void,
    bottom?: () => void
}

export default function useSwipe(callbacks: Callbacks) {
    const touchStart = useRef<Record<string, number> | null>(null);
    const touchEnd = useRef<Record<string, number> | null>(null);
    const minSwipeDistance = 50;

    const onTouchStart = (event: React.TouchEvent<HTMLDivElement>): void => {
        touchStart.current = {x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY};
    }

    const onTouchMove = (event: React.TouchEvent<HTMLDivElement>): void => {
        if (! touchStart.current) {
            return;
        }

        touchEnd.current = {x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY};
    }

    const onTouchEnd = (event: React.TouchEvent<HTMLDivElement>): void => {
        if (! touchStart.current || ! touchEnd.current) {
            return;
        }

        const distanceX = touchStart.current.x - touchEnd.current.x;
        const distanceY = touchStart.current.y - touchEnd.current.y;
        const isLeftSwipe = distanceX > minSwipeDistance;
        const isRightSwipe = distanceX < -minSwipeDistance;
        const isTopSwipe = distanceY > minSwipeDistance;
        const isBottomSwipe = distanceY < -minSwipeDistance;

        if (Math.abs(distanceX) > Math.abs(distanceY)) {
            if (isLeftSwipe && callbacks.left) {
                callbacks.left.call(event);
            } else if (isRightSwipe && callbacks.right) {
                callbacks.right.call(event);
            }
        } else if (Math.abs(distanceY) > Math.abs(distanceX)) {
            if (isTopSwipe && callbacks.top) {
                callbacks.top.call(event);
            } else if (isBottomSwipe && callbacks.bottom) {
                callbacks.bottom.call(event);
            }
        }

        touchStart.current = null;
        touchEnd.current = null;
    }

    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd
    }
}